module.exports = __webpack_public_path__ + "static/media/cs_long.51849a3a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cs_long.svg
// module id = 1602
// module chunks = 0